import React, { useMemo, useState } from "react";
import { dedupeListings } from "../../utils/dedupeListings";
import "./Properties.css";
import { PuffLoader } from "react-spinners";
import HeroSearch from "../home/hero/HeroSearch";
import useEmlakjetProperties from "../../hooks/useEmlakjetProperties";
import SingleCheapAdvertCard from "../AdvertCard/SingleCheapAdvertCard";
import Whatsapp1 from "../Whatsapp1/Whatsapp1";
import Call1 from "../Call1/Call1";
const Properties = () => {

  const { data, isError, isLoading } = useEmlakjetProperties();

  const [filter, setFilter] = useState("");

  const listings = useMemo(() => {
    const items = dedupeListings(data);
    if (!filter.trim()) return items;
    const q = filter.toLowerCase();
    return items.filter(
      (property) =>
        (property.title &&
          typeof property.title === "string" &&
          property.title.toLowerCase().includes(q)) ||
        property.location?.city?.name?.toLowerCase().includes(q) ||
        property.location?.district?.name?.toLowerCase().includes(q) ||
        property.location?.town?.name?.toLowerCase().includes(q) ||
        property.categoryTypeName?.toLowerCase().includes(q) ||
        property.tradeTypeName?.toLowerCase().includes(q)
    );
  }, [data, filter]);

  if (isError) {
    return (
      <div className="wrapper">
        <span>Error while fetching data</span>
      </div>
    );
  }
  if (isLoading) {
    return (
      <div className="wrapper flexCenter" style={{ height: "60vh" }}>
        <PuffLoader
          height="80"
          width="80"
          radius={1}
          color="#c5955b"
          aria-label="puff-loading"
        />
      </div>
    );
  }


  return (

  
    <div className="wrapper">
      <Call1 />
      <Whatsapp1 />
      <HeroSearch filter={filter} setFilter={setFilter} />
      <div className="px-[3%] md:px-[6%]">
      <div className=" pt-10 pb-16 flex items-start justify-around gap-32 wrapper-alt-div">
 
      <div className="listing-cards-row">
          {listings.length === 0 ? (
            <p>Aramada bir ilan bulunamadı</p>
          ) : (
            listings.map((card) => (
              <SingleCheapAdvertCard card={card} key={card.id} />
            ))
          )}
        </div>
        
      </div>
    </div>
    </div>
  );
};

export default Properties;

